import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FacilityID } from "../../../constants/defaultKeys";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { getInPatientInvestigationsApi } from "../../../services/receptionist.services";
import useQuery from "../../../hooks/useQuery";
import {
  updateUrlSearchParams,
  parsePageParam,
  parseSearchParam,
} from "../../../helpers/urlFilters";
import InvestigationTable from "./InvestigationTable";
import { UiDataTable } from "../../ui";
import styles from "./Investigations.module.css";

const Investigations = () => {
  const navigate = useNavigate();
  const params = useQuery();
  const page = parsePageParam(params);
  const searchQuery = parseSearchParam(params);
  const { userDetails } = useContext(UserContext);
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  const setPage = (newPage) => {
    updateUrlSearchParams(navigate, { page: newPage });
  };

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    let queryParams = {
      page: page,
    };
    if (searchQuery) {
      queryParams.search = searchQuery;
      queryParams.page = 1;
    }
    const queryString = new URLSearchParams(queryParams);
    setLoading(true);
    getInPatientInvestigationsApi(
      getCookie(FacilityID) || userDetails?.currFacility,
      queryString
    )
      .then((res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [
    refresh,
    searchQuery,
    page,
    Number(getCookie(FacilityID)) || userDetails?.currFacility,
  ]);

  const onContactSearch = (value) => {
    updateUrlSearchParams(navigate, {
      search: value?.target?.value || null,
      page: 1,
    });
  };

  return (
    <div className={styles.receptionInvestigations}>
      <UiDataTable
        showHeader={false}
        shellClassName="ui-table-fill-shell"
        onSearch={onContactSearch}
        searchValue={searchQuery || ""}
        searchPlaceholder="Search for investigation"
      >
        <InvestigationTable
          loading={loading}
          data={data}
          refreshPage={refreshPage}
          page={page}
          setPage={setPage}
        />
      </UiDataTable>
    </div>
  );
};

export default Investigations;
